import React from "react";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import Logo from "./Logo";

const quickLinks = [
  { l: "Services", h: "#services" },
  { l: "About", h: "#about" },
  { l: "Testimonials", h: "#testimonials" },
  { l: "FAQ", h: "#faq" },
  { l: "Contact", h: "#contact" },
];

const services = [
  "GST Registration & Filing",
  "ITR Filing",
  "Tax Compliance",
  "Company Registration",
  "Accounting & Bookkeeping",
];

export const Footer = () => {
  return (
    <footer className="bg-foreground text-background" data-testid="site-footer">
      <div className="container mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo variant="light" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-background/70">
              A Tumakuru-based chartered accountancy firm helping individuals and
              businesses stay compliant, informed and confident — at affordable
              fees.
            </p>

            <div className="mt-8 space-y-3 text-sm">
              <a href="tel:7353626623" className="flex items-center gap-3 text-background/80 hover:text-primary" data-testid="footer-phone">
                <Phone className="h-4 w-4 text-primary" />
                +91 73536 26623
              </a>
              <a href="https://wa.me/917353626623" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-background/80 hover:text-primary" data-testid="footer-whatsapp">
                <MessageCircle className="h-4 w-4 text-primary" />
                WhatsApp Chat
              </a>
              <a href="mailto:tmpn6@outlook.com" className="flex items-center gap-3 text-background/80 hover:text-primary" data-testid="footer-email">
                <Mail className="h-4 w-4 text-primary" />
                tmpn6@outlook.com
              </a>
              <div className="flex items-start gap-3 text-background/80">
                <MapPin className="mt-0.5 h-4 w-4 flex-none text-primary" />
                <span>
                  Near Sarang College, Thammanna Layout,<br />
                  Gulur, Tumakuru – 572118, Karnataka
                </span>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-[Outfit] text-xs font-bold uppercase tracking-[0.2em] text-primary">
              Quick Links
            </h3>
            <ul className="mt-6 space-y-3">
              {quickLinks.map((l) => (
                <li key={l.h}>
                  <a href={l.h} className="text-sm text-background/70 hover:text-background" data-testid={`footer-link-${l.l.toLowerCase()}`}>
                    {l.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-[Outfit] text-xs font-bold uppercase tracking-[0.2em] text-primary">
              Services
            </h3>
            <ul className="mt-6 space-y-3">
              {services.map((s) => (
                <li key={s}>
                  <a href="#services" className="text-sm text-background/70 hover:text-background">
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-background/10 pt-8 text-xs text-background/50 sm:flex-row sm:items-center">
          <div data-testid="footer-copyright">
            © {new Date().getFullYear()} NP Associates. All rights reserved.
          </div>
          <div className="font-[Outfit] uppercase tracking-widest">
            GST & Income Tax Auditors · Tumakuru
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
